import { AxiosResponse } from 'axios';
import apiInterceptor from '../utils/axios';
import { ProgramaAcademico } from '../types/Academico/ProgramaAcademico';
import { Facultad } from '../types/Academico/Facultad';
import { ResponseApi } from '../types/Response/ResponseApi';

const SERV_BACK: string = process.env.REACT_APP_API_ACAD || '';
const APICONSULTA = 'api/Consulta/';

export default class AcadService {

    static async InformacionPorFacultad(facultad: string): Promise<Array<ProgramaAcademico>> {
        const response1: AxiosResponse<Array<ProgramaAcademico>> = await apiInterceptor.get(`${SERV_BACK}${APICONSULTA}InformacionPorFacultad/${facultad}`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

    static async ConsultaCarrerasActivas(): Promise<ResponseApi<Facultad>> {
        const response1: AxiosResponse<ResponseApi<Facultad>> = await apiInterceptor.get(`${SERV_BACK}${APICONSULTA}ConsultaCarrerasActivas`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

}